module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/skyline-marker-85c2ef6783d5fdccaf828461ed1ffe84.svg";